/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */

import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { AiOutlineDownload } from 'react-icons/ai';
import { Button, ButtonDropdown } from 'ypf-pas-general-ui-components';
import { BsPlusCircle, BsTrash } from 'react-icons/bs';
import { useDropzone } from 'react-dropzone';
import { useMemo } from 'react';

import useToast from '../../../../hooks/useToast';
import './AttachFileButtonHeader.scss';
import { formDateHour } from '../../../../utils/formatUtils';
import { useAppContext } from '../../../../context/AppProvider';
import { deleteAttachmentsDaily, postDownloadFilesPt } from '../../../../services/workReport';
import {
  deleteFilesRequestSDS,
  postDownloadFilesSDS
} from '../../../../services/serviceRequestAttachment';
import downloadFiles, {
  FILE_DOWNLOAD_TYPES,
  extensionCanOpenInBrowser
} from '../../../../utils/downloadFiles';
import { MAX_DOWNLOAD_SIZE, MAX_FILE_SIZE } from '../../../../constants/constants';

const getOneFileName = (filesToDownload, downloadType) => {
  if (filesToDownload.length === 1) {
    return filesToDownload[0].nombre;
  }
  if (downloadType === FILE_DOWNLOAD_TYPES.COMBINE_PDF) {
    return 'document.pdf';
  }

  return '';
};

const handleSDSDownload = async (
  filesToDownload,
  archivesId,
  isMonthly,
  downloadType,
  oneFile,
  select
) => {
  if (downloadType === FILE_DOWNLOAD_TYPES.INDIVIDUAL && !oneFile) {
    return Promise.all(
      filesToDownload.map((file) =>
        postDownloadFilesSDS(file.nombre, archivesId, [file.id], isMonthly, downloadType)
      )
    );
  }

  return postDownloadFilesSDS(oneFile, archivesId, select, isMonthly, downloadType);
};

const handlePtDownload = async (filesToDownload, downloadType, oneFile) => {
  if (downloadType === FILE_DOWNLOAD_TYPES.INDIVIDUAL && !oneFile) {
    return Promise.all(
      filesToDownload.map((file) =>
        postDownloadFilesPt(file.nombre, [file.idParteDiario], [file.id], downloadType)
      )
    );
  }
  const filesToDownloadWorkPartIds = filesToDownload.reduce((acc, file) => {
    if (!acc.includes(file.idParteDiario)) acc.push(file.idParteDiario);

    return acc;
  }, []);

  return postDownloadFilesPt(
    oneFile,
    filesToDownloadWorkPartIds,
    filesToDownload.map((file) => file.id),
    downloadType
  );
};

const handleLocalFilesDownload = (attachedFiles, select) => {
  const localFilesToDownload = attachedFiles
    .filter((dataFile) => select.some((selectedId) => dataFile.data.id === selectedId))
    .map((attached) => attached.file);

  if (localFilesToDownload.length) {
    const oneLocalFile = localFilesToDownload.length === 1 ? localFilesToDownload[0].name : '';
    const blob = new Blob(localFilesToDownload);

    downloadFiles(blob, oneLocalFile);
  }
};

const AttachFileButtonHeader = ({
  allDataFiles,
  setSelect,
  setDataFiles,
  setDeletedFiles,
  setAttachedFiles,
  archivesId,
  name,
  select,
  disableEdit,
  dataFiles,
  attachedFiles,
  permissions,
  downloadOptions,
  isMonthly
}) => {
  const { userInfo } = useAppContext();
  const { id } = useParams();

  const { setNewToast } = useToast();

  const formatFile = (file) => ({
    data: {
      id: file.name,
      nombre: file?.name,
      peso: file?.size,
      fechaSubida: formDateHour(new Date().toISOString()).newDate,
      usuario: userInfo?.name
    },
    file
  });

  const onDropAccepted = (files) => {
    const values = allDataFiles;
    // Archivos repetidos
    const repeatedAttachments = files.filter((adj) =>
      values?.some(
        (fileAdj) => fileAdj.nombre === adj.name || fileAdj.nombre === `${id}_${adj.name}`
      )
    );
    // Non-duplicate files
    const noRepeatedAttachments = files.filter(
      (adj) =>
        !values.some(
          (fileAdj) => fileAdj.nombre === adj.name || fileAdj.nombre === `${id}_${adj.name}`
        )
    );

    // Duplicate files are not uploaded
    // notify which files they are
    if (repeatedAttachments.length) {
      const quantitiesAttachments = repeatedAttachments.length > 1;

      setNewToast({
        type: 'ERROR',
        message: `${
          quantitiesAttachments
            ? `Los archivos
          ${repeatedAttachments.map(
            (repAdj, ind) => `${repAdj.name} ${ind + 1 === repeatedAttachments.length ? ',' : '-'}`
          )} ya se encuentran cargados`
            : `El archivo ${repeatedAttachments[0].name} ya se encuentra cargado`
        }`
      });
    }
    // Non-duplicate files are uploaded
    if (noRepeatedAttachments?.length) {
      const newFiles = noRepeatedAttachments.map((file) => formatFile(file));

      setAttachedFiles([...attachedFiles, ...newFiles]);
    }
  };

  const onDropRejected = (fileRejections) => {
    fileRejections.forEach((file) => {
      setNewToast({
        type: 'ERROR',
        message: `El archivo ${file.file.name} no se pudo cargar`
      });
    });
  };

  const { getRootProps, getInputProps, open } = useDropzone({
    onDropAccepted,
    onDropRejected,
    maxSize: MAX_FILE_SIZE,
    noClick: true,
    noKeyboard: true,
    accept: 'pdf,.PDF,.jpg,.JPG,.jpeg,.JPEG,.msg,.xls,.xlsx,.png,.doc,.docx,.pptx,.ppt',
    disabled: disableEdit
  });

  const deleteFile = async () => {
    try {
      const filesToDeleteIds = dataFiles
        .filter((dataFile) => select.some((selectedId) => dataFile.id === selectedId))
        .map((file) => file.id);
      const newDataFiles = dataFiles.filter(
        (dataFile) => !select.some((selectedId) => dataFile.id === selectedId)
      );
      const newAttachedFiles = attachedFiles.filter(
        ({ data }) => !select.some((selectedId) => data.id === selectedId)
      );

      if (name === 'PosLinea') {
        setDeletedFiles(true);
      }

      if (filesToDeleteIds.length) {
        setNewToast({
          type: 'INFO',
          message: 'Eliminando Archivos, por favor espere.'
        });

        if (name === 'SDS') {
          await deleteFilesRequestSDS(archivesId, filesToDeleteIds, isMonthly);
          setNewToast({
            type: 'SUCCESS',
            message: 'Archivo/s eliminados correctamente'
          });
        } else {
          const response = await deleteAttachmentsDaily(archivesId, filesToDeleteIds);

          setNewToast({
            type: 'SUCCESS',
            message: response
          });
        }
      }
      setDataFiles(newDataFiles);
      setAttachedFiles(newAttachedFiles);
      setSelect([]);
      if (newAttachedFiles.length < attachedFiles.length && !filesToDeleteIds.length) {
        setNewToast({
          type: 'SUCCESS',
          message: 'Archivos eliminados correctamente'
        });
      }
    } catch (err) {
      setNewToast({
        type: 'ERROR',
        message: err.message
      });
    }
  };

  const filesToDownload = useMemo(
    () => dataFiles.filter((dataFile) => select.some((selectedId) => dataFile.id === selectedId)),
    [select, dataFiles]
  );

  const download = async (downloadType) => {
    try {
      setNewToast({
        type: 'INFO',
        message: 'Descargando, por favor espere.'
      });

      const oneFile = getOneFileName(filesToDownload, downloadType);

      let res;

      if (filesToDownload.length) {
        if (name === 'SDS') {
          res = await handleSDSDownload(
            filesToDownload,
            archivesId,
            isMonthly,
            downloadType,
            oneFile,
            select
          );
        } else {
          res = await handlePtDownload(filesToDownload, downloadType, oneFile);
        }
      }

      if (res?.success || (res?.length && res.every((r) => r.success))) {
        setNewToast({
          type: 'SUCCESS',
          message: oneFile ? `Descargando ${oneFile}` : 'Descargando archivos.'
        });
      } else {
        setNewToast({
          type: 'ERROR',
          message: 'No se pudo completar con la descarga.'
        });
      }

      handleLocalFilesDownload(attachedFiles, select);
    } catch (err) {
      setNewToast({
        type: 'ERROR',
        message: err.message
      });
    }
  };

  const isNotOnlyPDFFiles = useMemo(
    () =>
      !!filesToDownload.find((file) => select.includes(file.id) && !file.nombre.endsWith('.pdf')),
    [select, filesToDownload]
  );

  const canOpenInBrowser = useMemo(() => {
    const openInBrowserFiles = dataFiles.reduce((acc, curr) => {
      if (!select.includes(curr.id)) return acc;
      if (
        extensionCanOpenInBrowser.some((ext) =>
          curr.nombre.toLowerCase().includes(ext.toLowerCase())
        )
      ) {
        return [...acc, curr.nombre];
      }

      return acc;
    }, []);

    return openInBrowserFiles.length > 1;
  }, [select, dataFiles]);

  const options =
    downloadOptions?.map((option) => ({
      label: option.nombre,
      onClick: () => download(option.id),
      disabled:
        /**
         * Deshabilitamos la opcion de combinar PDF si los archivos seleccionados contienen otra extension y
         * deshabilitamos el boton de abrir en navegador si es mas de un archivo.
         */
        (option.id === FILE_DOWNLOAD_TYPES.COMBINE_PDF && isNotOnlyPDFFiles) ||
        (option.id === FILE_DOWNLOAD_TYPES.BROWSER && canOpenInBrowser)
    })) || [];

  const totalDownloadSize = useMemo(
    () =>
      /**
       * Obtenemos el total del peso de los archivos seleccionados, filtrando por los ids seleccionados
       */
      dataFiles.reduce((acc, curr) => {
        if (!select.includes(curr.id)) return acc;

        return acc + curr.peso;
      }, 0) / 1024,

    [select, dataFiles]
  );

  const isDownloadLimitExceded = totalDownloadSize > MAX_DOWNLOAD_SIZE;

  return (
    <div className="d-flex styles-content-buttons align-items-center justify-content-between">
      <div className="containers-buttons download-files download-modal">
        <ButtonDropdown
          disabled={
            !select.length || (select.length && !permissions.download) || isDownloadLimitExceded
          }
          label={<AiOutlineDownload size={15} />}
          options={options}
        />
        <Button
          colorIcon={
            disableEdit || !select.length || (select.length && !permissions.delete)
              ? 'dark'
              : 'danger'
          }
          disabled={disableEdit || !select.length || (select.length && !permissions.delete)}
          icon={BsTrash}
          onClick={deleteFile}
          type="button"
          variant="light-gray"
          widthButton="40px"
        />
        {isDownloadLimitExceded && (
          <div className="container-alert">
            {/* el límite de descarga no está confirmado */}
            <p>
              Has alcanzado un total de {Math.ceil(totalDownloadSize)}KB. El límite de descarga es
              de {MAX_DOWNLOAD_SIZE} KB
            </p>
          </div>
        )}
      </div>
      <div {...getRootProps()}>
        <input {...getInputProps()} value={undefined} />
        <Button
          colorIcon={disableEdit || (!disableEdit && !permissions.upload) ? 'dark' : 'primary'}
          disabled={disableEdit || (!disableEdit && !permissions.upload)}
          fontSizeLabel="15px"
          icon={BsPlusCircle}
          iconRight
          label="Agregar adjunto"
          onClick={open}
          sizeIcon="17px"
          type="button"
          variant="light-gray"
          widthButton="180px"
        />
      </div>
    </div>
  );
};

export default AttachFileButtonHeader;

AttachFileButtonHeader.propTypes = {
  allDataFiles: PropTypes.arrayOf(PropTypes.object),
  setSelect: PropTypes.func.isRequired,
  setDataFiles: PropTypes.func.isRequired,
  setAttachedFiles: PropTypes.func.isRequired,
  onlyButtonDeletedFiles: PropTypes.bool,
  setDeletedFiles: PropTypes.func,
  archivesId: PropTypes.number,
  name: PropTypes.string,
  select: PropTypes.arrayOf(PropTypes.object),
  disableEdit: PropTypes.bool,
  dataFiles: PropTypes.arrayOf(PropTypes.object),
  attachedFiles: PropTypes.arrayOf(PropTypes.object),
  permissions: PropTypes.objectOf(PropTypes.any),
  isMonthly: PropTypes.bool,
  downloadOptions: PropTypes.arrayOf(PropTypes.object)
};

AttachFileButtonHeader.defaultProps = {
  allDataFiles: [],
  setDeletedFiles: () => {},
  onlyButtonDeletedFiles: false,
  archivesId: null,
  select: [],
  name: '',
  disableEdit: false,
  dataFiles: [],
  attachedFiles: [],
  permissions: {},
  isMonthly: false,
  downloadOptions: []
};
